var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64645 0.646447C2.84171 0.451184 3.15829 0.451184 3.35355 0.646447L5.35355 2.64645C5.54882 2.84171 5.54882 3.15829 5.35355 3.35355C5.15829 3.54882 4.84171 3.54882 4.64645 3.35355L3.5 2.20711V10C3.5 10.2761 3.27614 10.5 3 10.5C2.72386 10.5 2.5 10.2761 2.5 10V2.20711L1.35355 3.35355C1.15829 3.54882 0.841709 3.54882 0.646447 3.35355C0.451184 3.15829 0.451184 2.84171 0.646447 2.64645L2.64645 0.646447Z",
    fill: "#036B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.17e1bdd2846005bc879c45687f749e15.svg";
export { ForwardRef as ReactComponent };